export const environment = {
  prod: false,
  apiUrl: 'https://sbpay-api.bajiexch365.com/api',
  cryptoSecret: 'ASgO-57!,xdFhKjA',
  sentryDSN:
    'https://907247e1ca61f66538f59a03a3ba6ba1@o4509823956746240.ingest.us.sentry.io/4509823960940544',
};
